/*
 * Sdílený popup s kontaktním formulářem. Otevírá ho jakýkoli prvek s třídou .js-contact-popup:
 *   data-popup-title = nadpis (per locale z jazykové mutace),
 *   data-popup-form  = id hostitele (<div id="CpHost-…" hidden>) s vykresleným formulářem
 *                      (snippet contact-popup-host). Uzel se do popupu PŘESUNE (ne klonuje —
 *                      zůstanou navázané listenery) a po zavření se vrátí zpět. Před každým přesunem
 *                      dostane karta událost cfc:beforemove – formulář odstraní Turnstile widget
 *                      (přesunutý iframe Turnstile ztratí) a při dalším focusu vykreslí nový.
 * Bez data-popup-form se použije stará šablona <template id="ContactPopupContent"> (záloha).
 * Popup samotný je třída Popup z global-popup.js (načítá se v theme.liquid dřív než tenhle soubor).
 */
(function () {
	if (window.__contactPopupBound) return;
	window.__contactPopupBound = true;

	document.addEventListener('click', function (udalost) {
		var spoust = udalost.target.closest('.js-contact-popup');
		if (!spoust) return;
		udalost.preventDefault();
		if (typeof Popup === 'undefined') return;

		var popup = new Popup('plus', 'contact-popup');
		var titulek = spoust.getAttribute('data-popup-title') || '';
		if (titulek) popup.setTitle('<h3 style="margin-bottom: 0;">' + titulek + '</h3>');

		var obal = document.createElement('div');
		obal.className = 'contact-popup-content';

		var hostId = spoust.getAttribute('data-popup-form') || '';
		var host = hostId ? document.getElementById(hostId) : null;
		/* Hostitel obsahuje <style>, kartu a <script> — přesouvá se jen karta, styl platí i ze skrytého hostitele. */
		var karta = host ? host.querySelector('.cfc-card') : null;
		/* Hostitel existuje, ale karta v něm není = formulář už je v otevřeném popupu (opakovaný klik, stack popupů) → neotvírat další prázdný. */
		if (host && !karta) return;
		if (karta) {
			/* The form drops its Turnstile widget before every move (a moved iframe reloads and Turnstile
			   loses it); the next focus renders a fresh widget in the new place. */
			var announceMove = function () {
				try { karta.dispatchEvent(new CustomEvent('cfc:beforemove')); } catch (e) { /* old browser – the form re-renders on its own */ }
			};
			announceMove();
			obal.appendChild(karta);
			/* Popup.close() volá destroy() a odstraní celý svůj DOM — formulář by zmizel i s listenery.
			   Instance si proto před zničením uzel vrátí hostiteli (příští otevření = tentýž formulář). */
			var puvodniDestroy = popup.destroy.bind(popup);
			popup.destroy = function () {
				announceMove();
				try { host.appendChild(karta); } catch (e) { /* hostitel mohl zmizet s překreslením sekce v editoru */ }
				puvodniDestroy();
			};
		} else {
			var sablona = document.getElementById('ContactPopupContent');
			if (sablona) obal.innerHTML = sablona.innerHTML;
		}
		popup.setContent(obal);
		popup.show();
	});
})();
